import Immutable from 'immutable';

export const State = Immutable.fromJS({
  isGetting: false,
  isPutting: false,
  errMsg: '',
  userId: 0
});
